export default __webpack_public_path__ + "img/illustration.75fee60.svg";